export const Hide = ({ classes }: { classes: string[] }) => {
  return <style>{`${classes.join(', ')} { display: none !important; }`}</style>;
};
